import { ref } from "vue";

// 全局加载状态
const isLoading = ref(false);
const loadingText = ref("加载中");

export function useLoading() {
  const showLoading = (text = "加载中") => {
    loadingText.value = text;
    isLoading.value = true;
  };

  const hideLoading = () => {
    isLoading.value = false;
  };

  return {
    isLoading,
    loadingText,
    showLoading,
    hideLoading,
  };
}
